





import { Component, Inject, Prop, Vue } from 'vue-property-decorator';

import { FlyoutData, FlyoutDataItem, FlyoutDataI18n } from '@/lib/interfaces';
import FlyoutGroupItem from './components/FlyoutGroupItem/FlyoutGroupItem.vue';

@Component({
  name: 'FlyoutGroup',
  components: {
    FlyoutGroupItem,
  },
})
export default class FlyoutGroup extends Vue {
  @Prop({ required: true, type: Array }) groupData!: FlyoutData;
  @Prop({ required: true, type: String }) groupName!: string;
  @Inject('i18n') private localI18n: FlyoutDataI18n | undefined;

  generateKey(entry: FlyoutDataItem): string {
    const entryName = entry.nameI18nKey
      ? entry.nameI18nKey
      : entry.nameOverrideI18nKey
      ? entry.nameOverrideI18nKey
      : entry.name;
    return `menu-entry-${entryName}-${+new Date()}`;
  }
  pascalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
